import React from "react";

type ScreenType = {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
};

const useScreen = (): ScreenType => {
  const [screen, setScreen] = React.useState<ScreenType>({
    isMobile: false,
    isTablet: false,
    isDesktop: false,
  });
  const { isMobile, isTablet, isDesktop } = screen;

  const handleResize = () => {
    const width = window.innerWidth;

    setScreen({
      isMobile: width <= 767,
      isTablet: width >= 768 && width <= 1024,
      isDesktop: width > 1024,
    });
  };

  React.useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return { isMobile, isTablet, isDesktop };
};

export default useScreen;
